module.exports = __webpack_public_path__ + "static/media/offline-marketing.ef996382.svg";